import { Component, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { DialogService } from "../../../../services/dialog.service";
import { PhotoDialogComponent } from "../photo-dialog/c.component";
import { PhotoGalleryDialogComponent } from "../photo-gallery-dialog/photo-gallery-dialog.component";
import { CommandDialogComponent } from "../command-dialog/c.component";
import { MapDialogComponent } from "../map-dialog/map-dialog.component";
import { JSProxyService } from "../../../../services/jsproxy.service";

@Component({
    selector: 'app-common-dialogs',
    templateUrl: './common-dialogs.component.html',
    styleUrls: ['./common-dialogs.component.css'],
    standalone: false
})
export class CommonDialogsComponent {
  @ViewChild("commandContainer", { read: ViewContainerRef, static: true }) commandContainer;
  @ViewChild("photoContainer", { read: ViewContainerRef, static: true }) photoContainer;
  @ViewChild("photoGalleryContainer", { read: ViewContainerRef, static: true }) photoGalleryContainer;
  @ViewChild("mapContainer", { read: ViewContainerRef, static: true }) mapContainer;

  protected dialogService: DialogService;

  constructor(protected injector: Injector) {
    this.dialogService = injector.get(DialogService);

    var jsProxy = injector.get(JSProxyService);
    jsProxy.registerComponent("CommonDialogs", this, "");
  }

  public openCommandModal() {
    var componentRef = this.dialogService.open(this.commandContainer, CommandDialogComponent);
    return componentRef.instance;
  }
  public openPhotoModal() {
    var componentRef = this.dialogService.open(this.photoContainer, PhotoDialogComponent);
    return componentRef.instance;
  }
  public openPhotoGalleryModal() {
    var componentRef = this.dialogService.open(this.photoGalleryContainer, PhotoGalleryDialogComponent);
    return componentRef.instance;
  }
  public openMapModal() {
    var componentRef = this.dialogService.open(this.mapContainer, MapDialogComponent);
    return componentRef.instance;
  }
}
